module.exports = __webpack_public_path__ + "static/media/cart-done-icon.5598fef6.svg";